<template>
	<div style="width: 95%;margin: 0 auto;">
		<div
			style="width: 100%;height: 30px;border-left: 3px solid red;margin-top: 25px;font-size: 24px;font-weight: 800;padding-left: 25px;">
			专家智库
		</div>
		
		<div @click="isShow = !isShow" style="width: 200px;height: 30px;border: 1px solid #000;text-align: center;line-height: 30px;margin-top: 10px;">
			点击添加专家智库
		</div>

		<!-- <div style="width: 90%;margin-left: 3%;height: 40px;margin-top: 25px;box-shadow: #6e6e6e 0px 0px 10px;">
			<div @click="isShow = !isShow"
				style="width: 120px;height: 40px;font-weight: 800;text-align: center;line-height: 40px;font-size: 18px;margin-left: 20px;border: 1px solid #6e6e6e;box-sizing: border-box;">
				添加
			</div>
		</div> -->


		<div style="width: 100%;min-height: 300px;margin-top: 25px;">
			<div v-show="!isShow" style="height: 300px;text-align: center;line-height: 300px;">
				<div style="height: 100px;width: 100%;border-bottom: 1px dashed #6e6e6e;" v-for="(item,index) in zjzka">
					<div style="width: 50%;height: 100px;float: left;">
						<div style="width: 70%;height: 50px;line-height: 50px;text-align: left;font-size: 20px;font-weight: 800;color: #000;float: left;overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;">
							{{item.title}}
						</div>
					<!-- 	<div v-show="item.status=='0'"
							style="width: 20%;height: 30px;margin-top: 10px;border: 1px solid orangered;float: left;line-height: 30px;">
							待审核
						</div>
						<div v-show="item.status=='1'"
							style="width: 20%;height: 30px;margin-top: 10px;border: 1px solid orangered;float: left;line-height: 30px;">
							待审核
						</div>
						<div v-show="item.status=='2'"
							style="width: 20%;height: 30px;margin-top: 10px;border: 1px solid orangered;float: left;line-height: 30px;">
							待审核
						</div> -->
						<div style="width: 100%;height: 50px;line-height: 60px;float: left;text-align: left;">
							<span class="el-icon-time"></span>
							<span>发布时间：</span>{{getLocalTime(item.create_time)}}  <span style="margin-left: 20px;"></span>收益金额:<i class="iconfont icon-qianbao" style="margin-left: 5px;margin-right: 5px;"></i><span>{{item.sy_money}}</span>
						</div>
					</div>
					<div style="width: 50%;height: 100px;float: left;position: relative;">
						<div @click="xiugaia(item)"
							style="width: 100px;height: 30px;line-height: 30px;position: absolute;top: 10px;right: 20px;border: 1px solid #6e6e6e;">
							修改
						</div>
						<router-link tag="div" :to="{ path:'/zjzkdetail',query:{id:item.id,title:item.title} }"  style="width: 100px;height: 30px;line-height: 30px;position: absolute;top: 10px;right: 130px;border: 1px solid #6e6e6e;color: blue;">
							查看
						</router-link>
						<div @click="detela(item.id,item.mid)"
							style="width: 100px;height: 30px;line-height: 30px;position: absolute;bottom: 10px;right: 20px;border: 1px solid #6e6e6e;">
							删除
						</div>
					</div>
				</div>
				<!-- 分页 -->
				<div style="height: 40px;text-align: center;margin-top: 55px;">
					<el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage"
						:page-size="PageSize" layout="total, prev, pager, next" :total="Totals">
					</el-pagination>
				</div>
			</div>
			<div v-show="isShow">
				<div style="width: 100%;height: 50px;">
					<div
						style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;font-size:16px;">
						姓名:
					</div>
					<el-input v-model="form.title" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>

				<div style="width: 100%;height: 50px;">
					<div
						style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;font-size:16px;">
						头像:
					</div>
					<el-upload class="upload-demo" style="width: 200px;height: 30px;margin-top: 10px;float: left;"
						action="https://admin.shipoe360.com/api/picture/upload_pic" :on-preview="handlePreview"
						:on-remove="handleRemove" :before-remove="beforeRemove" :on-success="handsuccessss" :limit="1"
						:on-exceed="handleExceed" :file-list="fileListss">
						<el-button size="small" type="primary">点击上传</el-button>
					</el-upload>
				</div>

				<div style="width: 100%;height: 50px;margin-top: 25px;">
					<div
						style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;font-size:16px;">
						微信号:
					</div>
					<el-input v-model="form.wechat" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>

				<div style="width: 100%;height: 50px;">
					<div
						style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;font-size:16px;">
						邮箱:
					</div>
					<el-input v-model="form.mail" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>
				
				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						状态:
					</div>
					<el-radio-group v-model="form.onjob" style="margin-top: 5px;">
						<el-radio-button label="在职">在职</el-radio-button>
						<el-radio-button label="离职">离职</el-radio-button>
					</el-radio-group>
				</div>

				<div style="width: 100%;height: 50px;">
					<div
						style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;font-size:16px;">
						手机号码:
					</div>
					<el-input v-model="form.phone" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>

				<div style="width: 100%;height: 50px;">
					<div
						style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;font-size:16px;">
						职称:
					</div>
					<el-input v-model="form.position" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>


				<div style="width: 100%;height: 50px;">
					<div
						style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;font-size:16px;">
						公司:
					</div>
					<el-input v-model="form.company" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>
				
				
				<div style="width: 100%;height: 550px;">
					<div
						style="width: 40%;height: 50px;float: left;line-height: 50px;text-align: center;font-size:16px;">
						简介 <span style="font-size: 12px;">上传图片大小控制再“600 x 350”之间)</span> :
					</div>
					<div style="float: left;width: 90%;margin-left: 5%;height: 500px;">
						<vue-tinymce v-model="form.content" :setting="setting" />
					</div>
				</div>

				<div style="height: 50px;width: 200px;margin: 0 auto;">
					<el-button type="primary" @click="onSubmit">立即创建</el-button>
					<el-button @click="isShow = !isShow">取消</el-button>
				</div>

			</div>
		</div>
	</div>
</template>

<script>
	import http from "@/utils/http";
	export default {
		data() {
			return {
				isShow: false,
				fileListss: [],
				xsa: false,
				form: {
					title: '', //姓名
					picture: '', //头像
					describtion: '', //介绍
					wechat: '', //微信号
					mail: '', //邮箱
					phone: '', //手机号码
					position: '', //职称
					company: '', //公司名称
					content:'',
					onjob:'',
				},
				qid: '',
				zjzka: '',
				currentPage: 1, //当前页
				PageSize: 10, //当前每页数据
				Totals: 100, //总数据条数
				setting: {
					menubar: false,
					toolbar: 'code undo redo restoredraft | cut copy paste pastetext | forecolor backcolor bold italic underline strikethrough link anchor | alignleft aligncenter alignright alignjustify outdent indent | \
					styleselect formatselect fontselect fontsizeselect | bullist numlist | blockquote subscript superscript removeformat | \
					table image media charmap emoticons hr pagebreak insertdatetime print preview | fullscreen | bdmap indent2em lineheight formatpainter axupimgs ltr rtl | emoticons help | wordcount',
					toolbar_drawer: "sliding",
					quickbars_selection_toolbar: "removeformat | bold italic underline strikethrough | fontsizeselect forecolor backcolor",
					plugins: "link image media table lists fullscreen quickbars advlist autosave directionality emoticons help imagetools pagebreak preview print wordcount",
					language: 'zh_CN', //本地化设置
					height: 500,
					selector: '#textarea1',
					automatic_uploads: false,
					images_upload_url: 'https://admin.shipoe360.com/ueditorphp/controller.php',
					fontsize_formats: '12px 14px 16px 18px 24px 36px 48px 56px 72px',
					font_formats: '微软雅黑=Microsoft YaHei,Helvetica Neue,PingFang SC,sans-serif;苹果苹方=PingFang SC,Microsoft YaHei,sans-serif;宋体=simsun,serif;仿宋体=FangSong,serif;黑体=SimHei,sans-serif;Arial=arial,helvetica,sans-serif;Arial Black=arial black,avant garde;Book Antiqua=book antiqua,palatino;',
				
				},
			}
		},
		mounted() {
			this.getinfo()
		},
		methods: {
			handlePreview(file) {
				console.log(file);
			},
			getLocalTime(nS) {
				return new Date(parseInt(nS) * 1000).toLocaleString().replace(/:\d{1,2}$/, ' ');
			},
			handleExceed(files, fileList) {
				this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			},
			handleRemove(file, fileList) {
				console.log(file, fileList);
			},
			beforeRemove(file, fileList) {
				return this.$confirm(`确定移除 ${ file.name }？`);
			},
			handsuccessss(response, file, fileList) {
				this.form.picture = response.data.path
			},
			async detela(id, mid) {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				let res = await http.post('api/Common/delete', {
					model: 'expert',
					type: 'content',
					mid: '6',
					uid: loginInfo.id,
					field_name: 'id',
					fidle_id: id
				})
				if (res.data.code == 200) {
					this.$notify({
						title: '成功',
						message: '删除成功',
						type: 'success'
					});
					this.getinfo()
				}
			},
			xiugaia(val) {
				console.log(val)
				this.xsa = true
				this.isShow = true
				this.qid = val.id
				this.form.title = val.title
				this.form.picture = val.picture
				this.form.content = val.describtion
				this.form.wechat = val.wechat
				this.form.mail = val.mail
				this.form.phone = val.phone
				this.form.position = val.position
				this.form.company = val.company
				this.form.onjob = val.onjob
				
				if(this.form.picture === 'http://admin.shipoe360.com/public/'){
					this.form.picture = ''
				} else {
					this.form.picture = this.form.picture.replace(new RegExp('http://admin.shipoe360.com/public/','g'),'')
				}

				let fileArrss = [];
				let fileObjss = {};
				fileObjss.name = "图片";
				fileObjss.url = val.picture;
				fileArrss.push(fileObjss);
				this.fileListss = fileArrss
			},
			async handleCurrentChange(val) {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
					let res = await http.get('api/picture/personl_page_zjzk', {
						uid: loginInfo.id,
						page: val
					})
					console.log(res)
					this.zjzka = res.data.data.list
					this.Totals = res.data.data.count
					this.PageSize = res.data.data.rows_limit
				
			},
			async getinfo() {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				let res = await http.post('api/Common/index', {
					model: 'expert',
					type: 'content',
					mid: '6',
					uid: loginInfo.id
				})
				this.zjzka = res.data.data.list.data
				this.Totals = res.data.data.count
				this.PageSize = res.data.data.rows_limit
			},
			async onSubmit() {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				if (this.xsa == true) {
					let res = await http.post('api/Common/edit', {
						model: 'expert',
						type: 'content',
						mid: '6',
						id: this.qid,
						title: this.form.title,
						picture: this.form.picture,
						describtion: this.form.describtion,
						wechat: this.form.wechat,
						describtion:this.form.content,
						mail: this.form.mail,
						phone: this.form.phone,
						position: this.form.position,
						company: this.form.company,
						uid: this.cnmuid,
						onjob:this.form.onjob,
					})
					if (res.data.code == 200) {
						this.$notify({
							title: '成功',
							message: '上传成功',
							type: 'success'
						});
						this.getinfo()
						this.fileListss = []
						this.form.title = ''
						this.form.picture = ''
						this.form.describtion = ''
						this.form.wechat = ''
						this.form.mail = ''
						this.form.phone = ''
						this.form.position = ''
						this.form.content = ''
						this.form.company = ''
						this.form.onjob = ''
					}
				} else if (this.xsa == false) {
					let res1 = await http.post('api/Common/add', {
						model: 'expert',
						type: 'content',
						mid: '6',
						title: this.form.title,
						picture: this.form.picture,
						describtion: this.form.describtion,
						wechat: this.form.wechat,
						describtion:this.form.content,
						mail: this.form.mail,
						phone: this.form.phone,
						position: this.form.position,
						company: this.form.company,
						onjob:this.form.onjob,
						uid: loginInfo.id,
					})
					if (res1.data.code == 200) {
						this.$notify({
							title: '成功',
							message: '上传成功',
							type: 'success'
						});
						this.getinfo()
						this.fileListss = []
						this.form.title = ''
						this.form.picture = ''
						this.form.describtion = ''
						this.form.wechat = ''
						this.form.mail = ''
						this.form.phone = ''
						this.form.onjob = ''
						this.form.position = ''
						this.form.company = ''
						this.form.content = ''
					}
				}
			}
		}
	}
</script>

<style>
</style>
